<template>
  <div style="text-align: right;font-size:.9rem;margin:.8rem 1rem 0 0">
    <router-link to="/about">ForkStyleについて</router-link>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";

@Options({
  components: {
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  data() {
    return {
      heroImage: process.env.VUE_APP_MELON + process.env.VUE_APP_CDN + "/public-page/thumbnail/" + "default/7.jpg"
    };
  }
}
</script>

<style lang="scss" scoped>
/* .hero_container {
  background-color: white;
} */

.left_inner {
  text-align: center;
}

figure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: intrinsic;
}
.heroImage {
  width: 70%;
}
</style>